import * as React from "react";

import { isNonEmptyObject } from "@cayuse/shared-react.utils.type-checks";
import PropTypes from "prop-types";
import { Icon } from "semantic-ui-react";

import styles from "./styles.css";

const InfoCard = ({ items = [], onClose, canEdit = false }) => {
	const hasItems = items.length > 0;

	const renderItem = ({ key, value, url }, k) => {
		const isSingleValue =
			isNonEmptyObject(key) && key.type === "SINGLE_FORMATTED_VALUE";
		const isLeftRightAlignedValue =
			isNonEmptyObject(key) && key.type === "LEFT_RIGHT_ALIGNED_VALUE";
		const isBlockElement =
			isNonEmptyObject(key) && key.type === "SECTION_HEADER";

		if (isSingleValue) {
			return (
				<div key={`info-card-item-${k}`}>
					<span className={styles.bold}>{value}</span>
				</div>
			);
		} else if (isLeftRightAlignedValue) {
			return (
				<div key={`info-card-item-${k}`} className={styles.leftRightAligned}>
					<h4>{key.label}</h4>
					<span>{value}</span>
				</div>
			);
		} else {
			return (
				<div key={`info-card-item-${k}`} className={styles.row}>
					{isBlockElement ? (
						<div className={styles.sectionHeader}>
							<h4>{value}</h4>
						</div>
					) : (
						<div>
							<span className={styles.bold}>{key}: </span>
							{url ? (
								<a
									href={url}
									rel="noopener noreferrer"
									target="_blank"
								>
									{value}
								</a>
							) : (
								<span>{value}</span>
							)}
						</div>
					)}
				</div>
			);
		}
	};

	return (
		<div className={`ui card ${styles.infoCard}`}>
			<div className="content">
				<div className="description">
					{canEdit && (
						<div className={styles.closeButton}>
							<Icon onClick={onClose}>
								<i
									aria-hidden="true"
									className={`${styles.closeButtonIcon} times icon`}
								/>
							</Icon>
						</div>
					)}
					{hasItems ? (
						items.map(renderItem)
					) : (
						<span>"No items to show"</span>
					)}
				</div>
			</div>
		</div>
	);
};

InfoCard.propTypes = {
	card: PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.string,
		url: PropTypes.string
	}),
	onClose: PropTypes.func
};

export default InfoCard;
